import React from 'react';
import {Flex, Spinner} from '@chakra-ui/core';
import {showellNavHeight} from 'styles/constants';

const Loader = () => {
	return (
		<Flex pt={showellNavHeight} justifyContent="center" alignItems="center">
			<Spinner size="xl" color="white" />
		</Flex>
	);
};

export default Loader;
